// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, Related } from '../../contexts'

import { logger } from '../../support'

import { resolveImage } from '../resolvers'

import { CreationsModuleContentInput, CreationsModuleData, PointCoordinate } from './Creations.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const resolveCreationsModuleContent: ModuleContentResolver<CreationsModuleContentInput, CreationsModuleData> =
  async (input: CreationsModuleContentInput, relatedService: IRelatedService): Promise<CreationsModuleData> => {
    const image = await resolveImage(input.image, relatedService)
    let pointsCoordinates: PointCoordinate[] = []

    const toResolve = input.pointsCoordinates.filter(p => p.product !== null)

    try {
      pointsCoordinates = await Promise.all(
        toResolve.map(async ({ x, y, product }) => {
          return { x, y, product: await relatedService.resolve(product as Related) }
        })
      )
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      ...input,
      pointsCoordinates,
      image
    }
  }
